/* CREMA — JS propio (vanilla). Cada init comprueba si su elemento existe. */

document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCompare();
  initGallery();
  initVariantPicker();
  initTabs();
  initMascot();
  initStickyCta();
  initClips();
  initMascotScroll();
});

/* Revelado al hacer scroll */
function initReveal() {
  var els = document.querySelectorAll('.aq-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('aq-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('aq-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--aq-delay')) el.style.setProperty('--aq-delay', (i % 5) * 90);
    observer.observe(el);
  });
}

/* Comparador antes/después */
function initCompare() {
  document.querySelectorAll('.aq-compare').forEach(function (wrap) {
    var afterWrap = wrap.querySelector('.aq-compare__after-wrap');
    var handle = wrap.querySelector('.aq-compare__handle');
    if (!afterWrap || !handle) return;
    var dragging = false;

    function apply(pct) {
      wrap.style.setProperty('--aq-compare-pos', pct + '%');
      afterWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }
    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      apply(Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100)));
    }
    function down(x) { dragging = true; setPos(x); }
    function move(e) {
      if (!dragging) return;
      setPos(e.touches ? e.touches[0].clientX : e.clientX);
    }
    function up() { dragging = false; }

    wrap.addEventListener('mousedown', function (e) { down(e.clientX); });
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('touchend', up);

    handle.setAttribute('tabindex', '0');
    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(wrap.style.getPropertyValue('--aq-compare-pos')) || 50;
      if (e.key === 'ArrowLeft') apply(Math.max(0, cur - 5));
      else if (e.key === 'ArrowRight') apply(Math.min(100, cur + 5));
    });

    /* Pequeña demostración al entrar en pantalla: invita a deslizar */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var demoObs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        demoObs.disconnect();
        var t0 = null;
        function frame(t) {
          if (dragging) return;
          if (t0 === null) t0 = t;
          var p = (t - t0) / 1800;
          if (p >= 1) { apply(50); return; }
          apply(50 + Math.sin(p * Math.PI * 2) * 24 * (1 - p));
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }, { threshold: 0.6 });
      demoObs.observe(wrap);
    }
  });
}

/* Galería de producto: imagen principal + miniaturas */
function initGallery() {
  document.querySelectorAll('[data-aq-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-aq-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-aq-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        window.setTimeout(function () { main.setAttribute('src', full); main.style.opacity = '1'; }, 140);
        thumbs.forEach(function (t) { t.classList.remove('aq-active'); });
        thumb.classList.add('aq-active');
      });
    });
  });
}

/* Selector de variante (por si hay varias): id, imagen, precio y stock */
function initVariantPicker() {
  document.querySelectorAll('[data-aq-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var hiddenId = form ? form.querySelector('input[name="id"]') : null;
    var gallery = document.querySelector('[data-aq-gallery]');
    var main = gallery ? gallery.querySelector('[data-aq-gallery-main]') : null;
    var swatches = picker.querySelectorAll('[data-aq-swatch]');
    if (!swatches.length) return;
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('aq-active'); });
        swatch.classList.add('aq-active');
        var nameEl = document.querySelector('[data-aq-variant-name]');
        if (nameEl) nameEl.textContent = swatch.getAttribute('data-name') || '';
        var variantId = swatch.getAttribute('data-variant-id');
        if (hiddenId && variantId) hiddenId.value = variantId;
        var image = swatch.getAttribute('data-image');
        if (main && image) {
          main.style.opacity = '0';
          window.setTimeout(function () { main.setAttribute('src', image); main.style.opacity = '1'; }, 140);
        }
        var priceEl = document.querySelector('[data-aq-price]');
        if (priceEl && swatch.getAttribute('data-price')) priceEl.textContent = swatch.getAttribute('data-price');
        var cmpEl = document.querySelector('[data-aq-compare]');
        if (cmpEl) {
          var cmp = swatch.getAttribute('data-compare');
          cmpEl.textContent = cmp || '';
          cmpEl.hidden = !cmp;
        }
        var stock = parseInt(swatch.getAttribute('data-stock'), 10);
        var stockEl = document.querySelector('[data-aq-stock]');
        if (stockEl) {
          var limit = parseInt(stockEl.getAttribute('data-limit'), 10) || 0;
          if (!isNaN(stock) && stock > 0 && stock <= limit) {
            stockEl.hidden = false;
            var n = stockEl.querySelector('[data-aq-stock-n]');
            if (n) n.textContent = stock;
          } else {
            stockEl.hidden = true;
          }
        }
      });
    });
  });
}

/* Pestañas genéricas: [data-aq-tabs] con [data-aq-tab=clave] y [data-aq-panel=clave] */
function initTabs() {
  document.querySelectorAll('[data-aq-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-aq-tab]');
    var panels = root.querySelectorAll('[data-aq-panel]');
    if (!tabs.length) return;
    function show(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-aq-tab') === key;
        t.classList.toggle('aq-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-aq-panel') === key;
        p.hidden = !on;
        if (on) { p.classList.remove('aq-pop'); void p.offsetWidth; p.classList.add('aq-pop'); }
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-aq-tab')); });
    });
    show(tabs[0].getAttribute('data-aq-tab'));
    /* Las fotos de las pestañas ocultas se precargan cuando la sección está cerca de la pantalla */
    var preloaded = false;
    function preload() {
      if (preloaded) return;
      var r = root.getBoundingClientRect();
      if (r.top > window.innerHeight * 2 || r.bottom < -window.innerHeight) return;
      preloaded = true;
      window.removeEventListener('scroll', preload);
      root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    window.addEventListener('scroll', preload, { passive: true });
    preload();
  });
}

/* Mascota "Lia": ojos que siguen al cursor, frases y destellos al hacer clic */
function initMascot() {
  var m = document.querySelector('[data-aq-mascot]');
  if (!m) return;
  var pupils = m.querySelectorAll('[data-aq-pupil]');
  var bubble = m.querySelector('[data-aq-bubble]');
  var btn = m.querySelector('[data-aq-mascot-btn]');
  var lines = [
    '¡Hola, guapa! Soy Lia, tu asesora de belleza sin cita previa 💄',
    'Un buen perfilado cambia toda la cara. ¿Ya conoces el Lip Liner Tattoo?',
    'Truco: exfolia tus labios antes de aplicar y el color queda perfecto.',
    '10-15 minutos, tiras de la película y… ¡labios de infarto!',
    'Envío gratis a toda España, islas incluidas. Llega en 5-6 días 💋',
    '¿Rose Pink, Mauve, Brown o Cocoa? Hay un tono para ti.',
    'Belleza es sentirte tú. El resto son tonos ✨',
    'Tu rutina de skincare también merece un momento de spa.',
    'Dicen que la constancia es el mejor secreto de belleza.',
    'Psst: la protección solar de día es tu mejor aliada.'
  ];
  var i = Math.floor(Math.random() * lines.length);
  var hideTimer;

  function look(x, y) {
    var r = m.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height * 0.5;
    var dx = x - cx, dy = y - cy;
    var d = Math.sqrt(dx * dx + dy * dy) || 1;
    var k = Math.min(1, d / 160) * 3.6;
    pupils.forEach(function (p) { p.setAttribute('transform', 'translate(' + ((dx / d) * k).toFixed(2) + ' ' + ((dy / d) * k).toFixed(2) + ')'); });
  }
  window.addEventListener('mousemove', function (e) { look(e.clientX, e.clientY); }, { passive: true });
  window.addEventListener('touchmove', function (e) { if (e.touches[0]) look(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });

  function say(text) {
    if (!bubble) return;
    bubble.textContent = text;
    bubble.classList.add('aq-show');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () { bubble.classList.remove('aq-show'); }, 4600);
  }

  function sparkles() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = btn.getBoundingClientRect();
    for (var s = 0; s < 7; s++) {
      var el = document.createElement('span');
      el.className = 'aq-burst';
      el.textContent = s % 2 ? '✦' : '💋';
      el.style.left = (r.left + r.width / 2) + 'px';
      el.style.top = (r.top + r.height / 3) + 'px';
      var ang = (Math.PI * 2 * s) / 7 + Math.random() * 0.4;
      el.style.setProperty('--dx', Math.round(Math.cos(ang) * (50 + Math.random() * 40)) + 'px');
      el.style.setProperty('--dy', Math.round(Math.sin(ang) * (50 + Math.random() * 40) - 20) + 'px');
      document.body.appendChild(el);
      (function (node) { window.setTimeout(function () { node.remove(); }, 1100); })(el);
    }
  }

  if (btn) {
    btn.addEventListener('click', function () {
      m.classList.remove('aq-boo');
      void m.offsetWidth;
      m.classList.add('aq-boo');
      sparkles();
      say(lines[i % lines.length]);
      i++;
    });
  }
  var greeted = false;
  try { greeted = sessionStorage.getItem('blGreeted') === '1'; } catch (e) {}
  if (!greeted) {
    window.setTimeout(function () {
      say('¡Hola, guapa! Toca para un truco de belleza 💄');
      try { sessionStorage.setItem('blGreeted', '1'); } catch (e) {}
    }, 4500);
  }
}

/* Vídeos de demostración: se reproducen (sin sonido) al verse y se pausan al salir; toque = pausa/play */
function initClips() {
  var clips = document.querySelectorAll('[data-aq-clip]');
  if (!clips.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mark(v) { v.parentNode.classList.toggle('aq-paused', v.paused); }
  clips.forEach(function (v) {
    v.addEventListener('play', function () { mark(v); });
    v.addEventListener('pause', function () { mark(v); });
    v.parentNode.addEventListener('click', function () {
      if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
    });
    mark(v);
  });
  if (reduce || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
    });
  }, { threshold: 0.6 });
  clips.forEach(function (v) { obs.observe(v); });
}

/* Mascota: en móvil se oculta mientras se hace scroll y reaparece al parar */
function initMascotScroll() {
  var m = document.querySelector('.aq-mascot');
  if (!m || !window.matchMedia('(max-width: 749px)').matches) return;
  var timer = null;
  window.addEventListener('scroll', function () {
    m.classList.add('aq-away');
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { m.classList.remove('aq-away'); }, 900);
  }, { passive: true });
}

/* Barra de compra fija en móvil (aparece al pasar el botón principal) */
function initStickyCta() {
  var bar = document.querySelector('[data-aq-sticky]');
  var target = document.querySelector('[data-aq-sticky-target]');
  if (!bar || !target) return;
  /* La barra fija pulsa el botón principal: así pasa siempre por la validación de las ofertas (Kaching) */
  var barBtn = bar.querySelector('button');
  if (barBtn) {
    barBtn.addEventListener('click', function (ev) {
      ev.preventDefault();
      target.click();
      window.setTimeout(function () {
        var alertEl = document.querySelector('.kaching-bundles__collection-breaks-alert');
        if (alertEl && alertEl.getBoundingClientRect().height > 0) {
          alertEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 500);
    });
  }
  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    bar.classList.toggle('aq-show', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(target);
}
